
import React, { useState } from "react";
import UserContextProvider, { ContextModel, User } from "../interface/interfaces";

// import { login } from "../service/auth";


interface Props {
    children: React.ReactNode;
}

const Context: React.FC<Props> = (props) => {
    const [user, setUser] = useState<any>({
        id: 0,
        name: "",
        lastname: "",
        email: "",
        cards: [],
        dui: "",
        phone: "",
        photo: ""
    });

    const [event, setEvent] = useState<any>({

    })

    const [order, setOrder] = useState<any>({

    })

    //Codigo de pais para obtener los eventos por pais
    const [config, setConfig] = useState<any>({
        countryCode: "SV",
        storeKey: "SJ5b3V85JVtYZIfd8dvx_vacio"

        // countryCode: "RAF",
        // storeKey: "gMeW62zhi8Q5soBXHG4K"

        //WhholeCake:gMeW62zhi8Q5soBXHG4K
        //SV:SJ5b3V85JVtYZIfd8dvx
        //ZOU:bIWIyB4Wo48E48QAxW3S
    })

    const [events, setEvents] = useState<any>([]);

    const asignateEventData = (event: any) => {
        setEvent(event);
    };

    const asignateUser = (user: User) => {
        setUser(user);
    };

    const asignateOrderData = (order: any) => {
        setOrder(order);
    };

    const asignateConfig = (config: any) => {
        setConfig(config);
    }

    const asignateEventsArray = (events: any) => {
        setEvents(events);
    }





    const contextValue: ContextModel = {
        user,
        event,
        order,
        config,
        events,
        asignateEventsArray,
        asignateOrderData,
        asignateEventData,
        asignateUser,
        asignateConfig,
        //loginUser,
    };

    return (
        <UserContextProvider.Provider value={contextValue}>
            {props.children}
        </UserContextProvider.Provider>
    )
};

export default Context;